import Table from '@material-ui/core/Table';

/** @deprecated */
export default Table;
